import Vue from 'vue';
import VueI18n from 'vue-i18n';
import BootstrapVue from 'bootstrap-vue';
import { languages } from '../../locales';

Vue.use(VueI18n);
Vue.use(BootstrapVue);

export class VueProvider {
    static init(): void {
        const i18n = new VueI18n({
            locale: 'en',
            fallbackLocale: 'en',
            messages: Object.assign(languages)
        });

        let locale = $.cookie("locale");

        if (!locale) {
            locale = "en";
        }

        new Vue({
            el: '#app',
            i18n,
            data: {},
            methods: {

            },
            mounted: function () {
                let mydlfsite = $.cookie("mydlfsite"); //this.$cookies.get("mydlfsite"); //REPLACE
                this.$i18n.locale = locale; //this.$store.state.locale; //REPLACE

                if (mydlfsite) {
                    window.location.href = '/' + this.$i18n.locale;
                }
            }
        });
    }
}